import { render } from "./externaldataset-list.vue?vue&type=template&id=625663e7"
import script from "./externaldataset-list.vue?vue&type=script&lang=js"
export * from "./externaldataset-list.vue?vue&type=script&lang=js"

import "./externaldataset-list.vue?vue&type=style&index=0&id=625663e7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__